const NotificationRoutes = {
  countNotification: "/notifications/count/unread",
  notifications: "/notifications",
  sendNotification: "/notifications/send",
};

export default NotificationRoutes;
